import { render, staticRenderFns } from "./CreateAddressForm.vue?vue&type=template&id=74ba1a26&"
import script from "./CreateAddressForm.vue?vue&type=script&lang=js&"
export * from "./CreateAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./CreateAddressForm.vue?vue&type=style&index=0&id=74ba1a26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports